import { render } from "./indexProposalComponent.vue?vue&type=template&id=48c03dd7&scoped=true"
import script from "./indexProposalComponent.vue?vue&type=script&lang=js"
export * from "./indexProposalComponent.vue?vue&type=script&lang=js"

import "./indexProposalComponent.vue?vue&type=style&index=0&id=48c03dd7&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48c03dd7"]])

export default __exports__